import { Link } from "react-router-dom";
import fatcaFormCheckerLogo from "../../images/building-fatca.svg";

function ComingSoon() {
  return <span className="regulatoryAddOnBadge"><span>Add-on</span><span>Coming soon</span></span>;
}

export default function RegulatoryAddOns({ enabled, onOpenWizard }) {
  const FatcaCard = enabled.fatca ? Link : "button";
  return <>
    <div className="regulatoryAssistantStack" aria-label="AI assistants">
      <button type="button"
        className={`regulatoryAssistantCard${enabled.aiWizard ? "" : " regulatoryAssistantCard--disabled"}`}
        disabled={!enabled.aiWizard} onClick={onOpenWizard}>
        <div className="regulatoryAssistantIcon"><i className="bi bi-stars" aria-hidden="true" /></div>
        <strong>AI Wizard</strong>
        {enabled.aiWizard ? <span className="regulatoryAssistantComingSoon">Instant answers</span> : <ComingSoon />}
      </button>
    </div>
    <div className="regulatoryPolicyStack">
      <section className={`regulatoryPolicyPanel regulatoryPolicyPanel--compact${enabled.internalAmlPolicy ? "" : " regulatoryPolicyPanel--disabled"}`}>
        <div className="regulatoryPolicyIcon"><i className="bi bi-shield-check" aria-hidden="true" /></div>
        <div className="regulatoryPolicyCopy">
          <p className="regulatoryEyebrow">Internal Document</p>
          <h2>Internal AML Policy</h2>
          {!enabled.internalAmlPolicy && <button type="button" className="regulatoryPolicyButton" disabled>
            <span>Open</span><i className="bi bi-arrow-right" aria-hidden="true" />
          </button>}
        </div>
        {enabled.internalAmlPolicy ? <Link to="/admin/aml-policy" className="regulatoryPolicyButton">
          <span>Open</span><i className="bi bi-arrow-right" aria-hidden="true" />
        </Link> : <ComingSoon />}
      </section>
      <FatcaCard {...(enabled.fatca ? { to: "/fatca" } : { type: "button", disabled: true })}
        className={`regulatoryAssistantCard regulatoryFatcaCard${enabled.fatca ? "" : " regulatoryAssistantCard--disabled"}`}>
        <span className="regulatoryAssistantIcon"><img src={fatcaFormCheckerLogo} alt="" width={22} height={22} /></span>
        <strong>FATCA</strong>
        {!enabled.fatca && <ComingSoon />}
      </FatcaCard>
    </div>
  </>;
}
